export default __webpack_public_path__ + "static/media/background.b73aba43.jpg";